<!-- 
WebServicePushList.vue
功能：網路服務推動名單
作者：i9400538 陳博承
完成：2021-06-15
-->
<template>
  <div>
    <div class="container-fluid" style="overflow: hidden;">
      <div
        class="mb-3"
        :class="{'section-loading': infoLoading}"
        style="overflow: hidden;max-height: 140px;"
      >
        <div class="float-left w-75">
          <h4 class="mb-line text-green mt-0 mb-0">
            {{ categoryInfo.subcategory }}-{{ categoryInfo.category_name }}
            <a
              v-if="categoryInfo.upload_file"
              class="text-orange"
              style="text-decoration:none;"
            >
              <i style="cursor:pointer;" class="icon-attach ml-2" @click="download()"></i>點我
            </a>
          </h4>
          <div class="mb-line" style>
            <span
              class="font-weight-bold mr-2"
            >{{ categoryInfo.upload_date | dateFormat }} ~ {{ categoryInfo.end_date | dateFormat }}</span>
          </div>
          <div class="mb-line w-75">
            <span class="font-weight-bold mr-2">{{ categoryInfo.description }}</span>
          </div>
        </div>
        <div class="float-left w-25">
          <div class="mb-line">
            <span class="font-weight-bold mr-2">維護單位</span>
            <span>{{ categoryInfo.dev_name }}</span>
          </div>
          <div class>
            <span class="font-weight-bold mr-2">聯絡電話</span>
            <span>{{ categoryInfo.contact }}</span>
          </div>
          <div class="mb-line">
            <span class="font-weight-bold mr-2">聯絡分機</span>
            <span>{{ categoryInfo.contact_tel }}</span>
          </div>
          <div :class="{'section-loading': isLoading_btn}">
            <a class="btn btn-default m-0" @click="satisfactionModal" v-if="isBtnEnble">滿意度調查</a>
            <a class="btn btn-default m-0" @click="alreadyDone" disabled="disabled" v-else>滿意度調查</a>
            &nbsp;&nbsp;
            <button
            type="button"
            style="height:43px;"
            @click="backToIndex"
            class="position-absolute btn btn-default m-0"
            v-html="'<span style=\'font-size:1rem\'>回上一頁<span>'"
          ></button>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="container-fluid" :class="{'section-loading': isLoading}">
      <div class="row">
        <web-service-push-list-data-table
          :height="data_table_height"
          @update="updateSelection"
          @scheduled-access="ScheduledAccess"
          :table-data="tableData"
          :categoryInfo="categoryInfo"
        />
      </div>
    </div>

    <section class="container-fluid fixed-bottom">
      <div class="row">
        <div class="col-12"></div>
        <div class="col-9 col-sm-8 col-md-8"></div>
        <div class="col-3 col-sm-4 col-md-4 text-right">
          <button
            class="btn btn-primary"
            @click="panelOpen('groupModalOpen')"
            :disabled="!selection.length"
          >加入群組</button>
          <button
            class="btn btn-primary mr-0"
            @click="panelOpen('printModalOpen')"
            :disabled="!selection.length"
          >列印名條</button>
        </div>
      </div>
    </section>

    <!-- 列印名條 -->
    <print-modal :open="printModalOpen" :custs="selection" @close="panelClose('printModalOpen')" />

    <!-- 加入群組 -->
    <group-modal
      :open="groupModalOpen"
      :custs="selection"
      @submit="submitGroup"
      @close="panelClose('groupModalOpen')"
    />

    <!-- 滿意度調查 -->
    <satisfaction-modal
      :open="satisfactionModalOpen"
      @report="report"
      @close="panelClose('satisfactionModalOpen')"
    />

    <!-- 排訪 -->
    <scheduled-access
      :open="ScheduledAccessModalOpen"
      :record="currentRecord"
      :cat-info="categoryInfo"
      @close="panelClose('ScheduledAccessModalOpen')"
      @submit="submitScheduledAccess"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import PrintModal from "@/desktop/components/PrintModal";
import GroupModal from "@/desktop/components/GroupModal";
import WebServicePushListDataTable from "@/desktop/components/ListsArea/DataTable/WebServicePushListDataTable";
import SatisfactionModal from "@/desktop/components/ListsArea/SatisfactionModal";
import ScheduledAccess from "@/desktop/components/ListsArea/ScheduledAccess";
import {
  getWebServicePushList,
  getCategoryDetail,
  isSatisfactionSurveyFinish,
  queryBookedVisitEvent,
  downloadFile_m0
} from "@/service";
import { saveAs } from "file-saver";

export default {
  name: "WebServicePushList",
  mixins: [commonMixin],
  components: {
    WebServicePushListDataTable,
    SatisfactionModal,
    PrintModal,
    GroupModal,
    ScheduledAccess
  },
  data() {
    //data block layout
    return {
      isLoading_btn: true,
      isLoading: false,
      infoLoading: false,
      isBtnEnble: true,
      categoryInfo: {},
      printModalOpen: false,
      groupModalOpen: false,
      tableData: [],
      selection: [],
      satisfactionModalOpen: false,
      data_table_height: 0,
      ScheduledAccessModalOpen: false,
      currentRecord: {},
      fbMetaUrl: "",
      agntNewCathayNo: "",
      credentialsUrl: "",
    };
  },
  metaInfo() {
    return {
      meta: [
        { property: "og:type", content: "website" },
        { property: "og:url", content: this.fbMetaUrl },
        {
          property: "og:description",
          content:
            "開通國泰人壽網路服務，輕鬆管理保險大小事，點網址開通得7-11禮券及其它好禮！(若推薦人未帶出，可以輸入AG" +
            this.agntNewCathayNo +
            "為他打氣喔)"
        }
      ]
    };
  },
  methods: {
    ...mapActions(["setPageLock", "updateCustID"]),
    updateSelection(val) {
      this.selection = val;
    },
    PrintModal() {
      this.panelOpen("printModalOpen");
    },
    satisfactionModal() {
      this.panelOpen("satisfactionModalOpen");
    },
    report() {
      this.$toast.info({ title: "滿意度調查 已回報" });
      this.isBtnEnble = false;
      this.panelClose("satisfactionModalOpen");
    },
    backToIndex() {
      // 回上一頁
      this.$emit("change-status", "STATUS_SERVICE_RIGHT_LIST");
    },
    submitGroup(group) {
      // 加入群組導頁至 群組列表
      this.panelClose("groupModalOpen");
      this.$router.push({
        path: `/group/1`,
        query: { grp_id: group.grp_id, grp_name: group.grp_name }
      });
    },
    init() {
      // 資料初始化
      this.checkIsSatisfactionSurveyFinish();
      this.isLoading = true;
      getWebServicePushList(this.$store.state.userInfo.id).then(result => {
        this.isLoading = false;
        if (
          result.header &&
          result.header.status === "200" &&
          result.body.result &&
          result.body.result.length > 0
        ) {
          this.agntNewCathayNo = result.body.agntnewcathayno;
          this.credentialsUrl = result.body.credentialsurl || "https://was2.cathaylife.com.tw/ABWeb/servlet/HttpDispatcher/ABW3_0002/prompt";
          this.fbMetaUrl =
            "https://cathay.app.link/2NuVYQEpTgb?promotion=AG&eid=" +
            this.agntNewCathayNo;
          let connect = "";
          let CsidData = "";
          result.body.result.map(item => {
            connect = connect + "," + item.id;
          });
          if (connect.length > 0) {
            CsidData = connect.substr(1);
          }
          queryBookedVisitEvent(this.$store.state.userInfo.id, CsidData).then(
            visitData => {
              this.isLoading = false;
              if (visitData.header && visitData.header.status === "200") {
                let visitList = visitData.body.detail;
                this.tableData = result.body.result.map(item => {
                  let visit = { visit: {} };
                  visitList.forEach(vItem => {
                    if (vItem.csidno == item.id) {
                      visit.visit = vItem;
                    }
                  });
                  return {
                    id: item.id || "", //客戶ID
                    name: item.name || "", //客戶姓名
                    sex: Number(item.id[1]) || "", //性別
                    vip_level: item.vip_lvl, // 顯示VIP
                    policy_no: item.policy_no || "", //保單號碼
                    mobile: item.mobile || "", //手機號碼
                    is_exist: item.is_exist || false, //判斷是否有客戶資料
                    is_inv: item.is_inv == 'Y' ? '■ 󠇈具投資型保單' : '',//是否具投資型保單
                    //recommend: item.recommend =='N'? '雙證件拍照' : item.recommend =='Q'? '世華網銀' : "",
                    recommend: item.recommend =='N'? '雙證件拍照' : item.recommend =='Q'? '雙證件拍照' : "",
                    //shareUrl: item.recommend =='N'? this.credentialsUrl : item.recommend =='Q'? "https://cathaylife.tw/ZN4n1W" : "",
                    shareUrl: item.recommend =='N'? this.credentialsUrl : item.recommend =='Q'? this.credentialsUrl  : "",
                    /*shareText: item.recommend =='N'? "【國泰人壽】開通網路服務，輕鬆管理保險大小事，點網址開通得小樹點再享其它大獎中獎機會！(若推薦人未帶出，可以輸入"+this.agntNewCathayNo+"為他打氣喔) 申辦請點擊 "+this.credentialsUrl+" ；操作說明 https://cathaylife.tw/jvVApA ；開通後請下載國泰優惠APP： https://cathaylife.tw/LvnEGd 經確認符合資格，且須開通完成，次月底即可於國泰優惠APP取得小樹點哦！"
                    : item.recommend =='Q'? "【國泰人壽】開通網路服務，輕鬆管理保險大小事，點網址開通得小樹點再享其它大獎中獎機會！(若推薦人未帶出，可以輸入"+this.agntNewCathayNo+"為他打氣喔) 申辦請點擊 https://cathaylife.tw/ZN4n1W ；操作說明 https://cathaylife.tw/EAZA90 ；開通後請下載國泰優惠APP： https://cathaylife.tw/LvnEGd 經確認符合資格，且須開通完成，次月底即可於國泰優惠APP取得小樹點哦！"
                    : "",*/
                    shareText: item.recommend =='N'? "【國泰人壽】誠摯邀請您申辦「網路服務」與「電子單據」，輕鬆管理保險大小事。快速申辦連結 "+this.credentialsUrl+" ；倘申辦過程有疑問，歡迎洽詢您的服務人員，也不忘在推薦人輸入"+this.agntNewCathayNo+"為她打氣哦!" 
                    : item.recommend =='Q'? "【國泰人壽】誠摯邀請您申辦「網路服務」與「電子單據」，輕鬆管理保險大小事。快速申辦連結 "+this.credentialsUrl+" ；倘申辦過程有疑問，歡迎洽詢您的服務人員，也不忘在推薦人輸入"+this.agntNewCathayNo+"為她打氣哦!"
                    : "",
                    ...visit // 寫入排訪資料
                  };
                });
              }
            }
          );
          this.registerHanlink(); // for hard word
        }
      });
      this.getTitleInfo();
    },
    getTitleInfo() {
      // 取得專區資訊
      this.infoLoading = true;
      getCategoryDetail(
        this.$store.state.userInfo.id,
        this.$store.state.listAreaSerNo
      ).then(result => {
        this.infoLoading = false;
        if (result.header && result.header.status == "200") {
          this.categoryInfo = result.body[0];
        }
      });
    },
    checkIsSatisfactionSurveyFinish() {
      // 檢查是否已回報過滿意度調查
      this.isLoading_btn = true;
      isSatisfactionSurveyFinish(
        this.$store.state.userInfo.id,
        this.$store.state.listAreaSerNo
      ).then(result => {
        if (result.header && result.header.status == "200") {
          this.isBtnEnble = result.body.isfinish == "0";
        } else {
          if (result.header && result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "查詢滿意度調查失敗,請重新操作" });
          }
        }
        this.isLoading_btn = false;
      });
    },
    alreadyDone() {
      this.$toast.info({ title: "您已回報過滿意度調查,無法重複操作" });
    },
    ScheduledAccess(record) {
      this.currentRecord = record;
      this.panelOpen("ScheduledAccessModalOpen");
    },
    submitScheduledAccess() {
      this.panelClose("ScheduledAccessModalOpen");
      // 資料初始化
      this.init();
    },
    download() {
      if (this.$store.state.userInfo.userType === "box") {
        //若内嵌於Box, 將檔案資訊回傳給Box
        this.boxDownload(
          this.categoryInfo.upload_file,
          this.categoryInfo.ser_no
        );
      } else {
        let vm = this;
        downloadFile_m0(
          this.$store.state.userInfo.id,
          this.categoryInfo.ser_no,
          this.categoryInfo.upload_file
        ).then(result => {
          if (result.type == "application/json") {
            //  json 為檔案下載失敗
            //  把回傳的 blob 轉為 文字檔後再用 json parse
            let reader = new FileReader();
            reader.onload = function() {
              let unicodeJsonA = JSON.parse(reader.result);
              if (unicodeJsonA.header.message) {
                vm.setToastMsg(unicodeJsonA.header.message);
              } else {
                vm.setToastMsg("伺服器連線異常");
              }
            };
            reader.readAsText(result);
          } else {
            //  成功取得檔案  進行下載
            saveAs(result, this.categoryInfo.upload_file);
          }
        });
      }
    }
  },
  mounted() {
    // 資料初始化
    this.init();
    this.data_table_height =
      parseInt($(window).height()) - $("tbody").offset().top - 80;
    let self = this;
    $(window).bind("resize", function(event) {
      self.data_table_height =
        parseInt($(window).height()) - $("tbody").offset().top - 80;
    });
    $(".tab-content").css("padding-bottom", "74px");
  }
};
</script>
